import React, { useEffect, useMemo, useState } from 'react';
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import SurveyData from 'app/components/ServicesForms/Survey/SurveyData';
import surveyEndpoint from 'app/api/services/surveyEndpoint';
import { CircularProgress, makeStyles } from '@material-ui/core';

import styles from './styles';
import { fetchSubitemComponent, fetchSystemClassification } from 'app/store/slices/survey';
const useStyles = makeStyles(styles);

function Survey(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const request = useSelector(state => state.requests.details);
  const systemClassification = useSelector(state => state.survey.systemClassification);
  const subitemComponent = useSelector(state => state.survey.subitemComponent);

  const canEdit = useMemo(() => {
    return false;
  }, []);

  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      try {
        const promisses = [];
        if (systemClassification.length === 0) {
          promisses.push(dispatch(fetchSystemClassification()));
        }
        if (subitemComponent.length === 0) {
          promisses.push(dispatch(fetchSubitemComponent()));
        }
        if (promisses.length > 0) {
          await Promise.all(promisses);
        }
        const response = await surveyEndpoint.getSurveyByRequest(request.cdSolicitacao);
        if (response?.status === 200 && response.data) {
          setSelectedSurvey(response.data);
        }
      } catch (error) {}
      setLoading(false);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, request.cdSolicitacao]);

  const contextProvider = useMemo(() => {
    return {
      isInternalForm: true,
      hideActionBtn: false,
      hideFinalizeBtn: true,
      mainColor: 'secondary',
      canEdit,
    };
  }, [canEdit]);

  if (loading) {
    return (
      <div className={classes.centerProgress}>
        <CircularProgress size={20} />
      </div>
    );
  }

  return (
    <div className={classes.containerSurvey}>
      <SurveyData
        {...props}
        contextProps={contextProvider}
        request={request}
        survey={selectedSurvey}
      />
    </div>
  );
}

export default injectIntl(Survey);
